type ErrorEventLike = {
  level?: string;
  exception?: { values?: { mechanism?: { handled?: boolean } }[] };
};

const FATAL_LEVEL = 'fatal';

// Structural check so this stays free of a Sentry dependency; both apps' beforeSend use it.
export const isUnhandledErrorEvent = (event: unknown): boolean => {
  if (!event || typeof event !== 'object') {
    return false;
  }
  const { level, exception } = event as ErrorEventLike;
  if (level === FATAL_LEVEL) {
    return true;
  }
  const values = exception?.values;
  return (
    Array.isArray(values) &&
    values.some((value) => value?.mechanism?.handled === false)
  );
};
